module.exports = __webpack_public_path__ + "img/cover16.9ce05b92.png";